import { axiosMiddleware } from "../../../../../../../../../../services/utilities";
import { BROWSE } from "../../../../../../../../../../services/indexDB/commerce/market/machines";
const A15 = async (workID, services, pi, machine, domain) => {
  const dbServices = await BROWSE(machine);

  const tests = services
    ?.map((id) => {
      const code = dbServices.find((s) => Number(s.id) === Number(id))?.code;
      return code ? `N SER ${pi} ${code} T15 ${id}` : "";
    })
    .filter(Boolean);
  // if (tests.length === 0) return `No test found for`;
  await axiosMiddleware.sendToA15({ tests, pi, _id: workID }, domain);
};

export default A15;
